<template>
  <div>
    <page-header>
      <div slot="content">
        <header-title link="/contact" title="Contact"></header-title>
      </div>
    </page-header>
    <div id="copy" class="body">
      <div class="block block-left">
        <p>For all general inquiries:</p>
        <p><a href="mailto:stuff@studio308.co" class="link-main">stuff@studio308.co</a></p>
        <p>To inquire about investing in one of our projects:</p>
        <p><a href="mailto:finance@studio308.co" class="link-main">finance@studio308.co</a></p>
      </div>
      <div class="block block-right">
        <p>We want you to reach out to us. We're lonely. Have a question about one of our projects? We guarantee it's not a dumb question because there's no such thing, so ask away. Need a few guns for hire for something you're working on? We do that. Need to send your product to urgent care to see a doctor? We're open twenty-four seven. Just want to pay someone to build and maintain your product? Yeah, we do that, too. Maybe you have a sick idea you want implemented but don't have the technical or financial resources to get it to see the light of day? If we agree with your subjective assessment of the idea's sickness, we'll see if we can't figure out a way for all of us to benefit from forcing it into the light together. Or maybe you just want to tell us a funny joke or interesting quote or see if we share the same favorite movie. We're interested. Hit us up. Send us an email at <a href="mailto:stuff@studio308.co" class="link-main">stuff@studio308.co</a>.</p>
        <p>Now if you saw a project on our site that made you think "oh, I gotta be a part of that, and look at all this money I don't know what to do with", then yep, you guessed it, we want you to get in touch with us. We even splurged and created a specific email address just for those facing dilemmas exactly like the one you're facing right now. Send us an email at <a href="mailto:finance@studio308.co" class="link-main">finance@studio308.co</a>.</p>
      </div>
      <div class="clear"></div>
    </div>
  </div>
</template>

<script>
import HeaderTitle from '@/components/HeaderTitle'
import PageHeader from '@/components/PageHeader'
export default {
  name: 'contact',
  data () {
    return {
      msg: 'Studio 308 Contact'
    }
  },
  components: {
    HeaderTitle,
    PageHeader
  }
}
</script>



// WEBPACK FOOTER //
// Contact.vue?16810533